// to migrate from hashHistory to browserHistory, simply change which import is used,
// then add a catchall route to the server to always serve the react app, regardless of the route

import { createHashHistory } from 'history';
// import createHistory from 'history/createBrowserHistory'; // not currently working

export default createHashHistory();
